import React, { useState, useEffect, useRef } from 'react';
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { AddOutlined, AutorenewOutlined, FilterList } from '@mui/icons-material';
import { useCategory } from './IpProvider';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment';
import PropTypes from "prop-types";

const operators = [
    { label: 'Contains', value: 'contains' },
    { label: 'Does Not Contain', value: 'doesNotContains' },
    { label: 'Equals', value: 'equals' },
    { label: 'Not Equals', value: 'notEquals' },
    { label: 'Starts With', value: 'startsWith' },
    { label: 'Ends With', value: 'endsWith' },
    { label: 'Is Empty', value: 'isEmpty' },
    { label: 'Is Not Empty', value: 'isNotEmpty' },
    { label: 'Is Any Of', value: 'isAnyOf' }
];

const MultiFilter = ({ columns, onAddFilter }) => {

    const { category } = useCategory();
    const filterIdRef = useRef(0);

    const getNextFilterId = () => {
        filterIdRef.current += 1;
        return filterIdRef.current;
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const [filters, setFilters] = useState(() => [{ id: getNextFilterId(), column: '', operator: '', value: '' }]);
    useEffect(() => {
        setFilters([{ id: getNextFilterId(),column: columns[0]?.field || '', operator: operators[0]?.value || '', value: '' }]);
        onAddFilter([]);
    }, [category])

    useEffect(() => {
        if (filters.every(f => f.column === '' && f.operator === "")) {
            setFilters(filters.map(f => ({ ...f, column: columns[0].field, operator: operators[0].value })));
        }
    }, [columns, operators, filters]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAddFilter = () => {
        onAddFilter(filters);
        handleClose();
    };

    const handleFilterChange = (index, field, value) => {
        const updatedFilters = [...filters];
        updatedFilters[index] = { ...updatedFilters[index], [field]: value };
        setFilters(updatedFilters);
    };

    const handleAddFilterInput = () => {
        setFilters([...filters, {id: getNextFilterId(), column: columns[0]?.field || '', operator: operators[0]?.value || '', value: '' }]);
    };

    const handleRemoveFilter = (index) => {
        if (filters.length === 1) {
            handleClose();
        } else if (filters.length > 1) {
            setFilters(filters.filter((_, i) => i !== index));
        }
    };

    const handleClearFilters = () => {
        setFilters([{ id: getNextFilterId(), column: columns[0]?.field || '', operator: operators[0]?.value || '', value: '' }]);
        onAddFilter([]);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'filter-menu' : undefined;
    const renderFilterValue = (filter, index) => {
        if (filter.column === "batch_date") {
            return (
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                value={filter.value && moment(filter.value).format('YYYY-MM-DD')}
                onChange={(newValue) => handleFilterChange(index, 'value', newValue ? moment(newValue).format('YYYY-MM-DD') : '')}
                format="YYYY-MM-DD"
                renderInput={(params) => <TextField
                sx={{ minWidth: 120, maxWidth: 200 }}
                {...params} size='small' />}
                />
            </LocalizationProvider>                            
                               
            );
        }

        if (filter.column === "priority_date") {
            return (
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                    value={filter.value ? moment(filter.value, ['MM/DD/YYYY', 'YYYY-MM-DD']) : null}
                    onChange={(newValue) =>
                    handleFilterChange(index,'value',newValue ? newValue.format('MM/DD/YYYY') : '')
                            }
                    format="MM/DD/YYYY"
                    renderInput={(params) => (
                    <TextField {...params} size="small" sx={{ minWidth: 120, maxWidth: 200 }} />
                    )}
                    />         
                </LocalizationProvider>
            );
        }

        return (
            <TextField
                value={filter.value}
                disabled={
                    filter.operator === "isEmpty" ||
                    filter.operator === "isNotEmpty"
                }
                onChange={(e) =>
                    handleFilterChange(index, "value", e.target.value)
                }
                placeholder="Filter value"
                size="small"
                sx={{
                    minWidth: 120,
                    maxWidth: 200,
                }}
            />
        );
    };
    return (
        <>
            <Button size="small"
                startIcon={<FilterList />}
                variant="text" onClick={handleClick} >
                Filter
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
            >
                <Box sx={{ padding: 2, }}>
                    {filters.map((filter, index) => (
                        <Box key={filter.id} sx={{ marginBottom: 2, display: 'flex', alignItems: 'center' }}>
                            <Box sx={{
                                flexGrow: 1,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2
                            }}>
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                    }}
                                >
                                    {/* <InputLabel>Column</InputLabel> */}
                                    <Select
                                        value={filter.column}
                                        onChange={(e) => handleFilterChange(index, 'column', e.target.value)}
                                        displayEmpty
                                        fullWidth
                                        size='small'
                                    >
                                        {columns.map((col) => (
                                            <MenuItem key={col.field} value={col.field}>
                                                {col.headerName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                                <Box sx={{
                                    flexGrow: 1,
                                }}>
                                    {/* <InputLabel>Operator</InputLabel> */}
                                    <Select
                                        value={filter.operator}
                                        onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                                        displayEmpty
                                        fullWidth
                                        size='small'
                                        sx={{ minWidth: 120 }}
                                    >
                                        {operators.map((op) => (
                                            <MenuItem key={op.value} value={op.value}>
                                                {op.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                                <Box>
                                    {renderFilterValue(filter, index)}
                                </Box>
                            </Box>
                            <IconButton onClick={() => handleRemoveFilter(index)} sx={{ marginLeft: 1 }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    ))}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                            <Button onClick={handleAddFilterInput} variant="outlined"

                            >
                                <AddOutlined />
                            </Button>
                            <Button onClick={handleClearFilters} variant="outlined">
                                <AutorenewOutlined />
                            </Button>
                        </Box>
                        <Box>
                            <Button onClick={handleAddFilter} disabled={filters.some(filter => filter.value === "")} variant="contained">
                                Apply Filters
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Popover>
        </>
    );
};
MultiFilter.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      headerName: PropTypes.string,
    })
  ).isRequired,
  onAddFilter: PropTypes.func.isRequired,
};
export default MultiFilter;
